import { Routes } from '@angular/router';
import { KaryawanAddCanLeaveGuard } from './employee/karyawan/karyawan-add/karyawan-add.page';
import { PermissionGuard, RedirectPermissionGuard } from 'src/guards/permission.guard';
import { Module } from 'src/definitions/permission.definition';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
    children: [
      {
        path: '',
        loadComponent: () => import('./loading/loading.page').then((m) => m.LoadingPage),
        canActivate: [RedirectPermissionGuard],
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardPage),
        canActivate: [PermissionGuard],
        data: {
          access: Module.DASHBOARD,
        },
      },
      {
        path: 'karyawan',
        loadComponent: () =>
          import('./employee/karyawan/karyawan-list/karyawan-list.page').then(
            (m) => m.KaryawanListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.DAFTAR_KARYAWAN,
        },
      },
      {
        path: 'divisi',
        loadComponent: () =>
          import('./employee/divisi/divisi-list/divisi-list.component').then(
            (m) => m.DivisiListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.DAFTAR_DIVISI,
        },
      },
      {
        path: 'group',
        loadComponent: () =>
          import('./employee/group/group-list/group-list.page').then((m) => m.GroupListPage),
        canActivate: [PermissionGuard],
        data: {
          access: Module.DAFTAR_GROUP,
        },
      },
      {
        path: 'jabatan',
        loadComponent: () =>
          import('./employee/jabatan/jabatan-list/jabatan-list.component').then(
            (m) => m.JabatanListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.DAFTAR_JABATAN,
        },
      },
      {
        path: 'kontrak',
        loadComponent: () =>
          import('./employee/kontrak/kontrak-list/kontrak-list.component').then(
            (m) => m.KontrakListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.DAFTAR_KONTRAK,
        },
      },
      {
        path: 'lokasi',
        loadComponent: () =>
          import('./employee/lokasi/lokasi-list/lokasi-list.component').then(
            (m) => m.LokasiListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.LOKASI_PENEMPATAN,
        },
      },
      {
        path: 'pengajuan',
        loadComponent: () =>
          import('./pengajuan/pengajuan-list/pengajuan-list.page').then((m) => m.PengajuanListPage),
        canActivate: [PermissionGuard],
        data: {
          access: Module.PENGAJUAN,
        },
      },
      {
        path: 'absensi',
        loadComponent: () =>
          import('./attendance/absensi/absensi-list/absensi-list.page').then(
            (m) => m.AbsensiListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.ABSENSI_HARIAN,
        },
      },
      {
        path: 'performa',
        loadComponent: () =>
          import('./attendance/performa/performa-list/performa-list.page').then(
            (m) => m.PerformaListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.LAPORAN_PERFORMA,
        },
      },
      {
        path: 'shift',
        loadComponent: () =>
          import('./schedule/shift/shift-list/shift-list.page').then((m) => m.ShiftListPage),
        canActivate: [PermissionGuard],
        data: {
          access: Module.SHIFT,
        },
      },
      {
        path: 'jadwal',
        loadComponent: () =>
          import('./schedule/jadwal/jadwal-list/jadwal-list.page').then((m) => m.JadwalListPage),
        canActivate: [PermissionGuard],
        data: {
          access: Module.POLA_JADWAL,
        },
      },
      {
        path: 'bulanan',
        loadComponent: () =>
          import('./schedule/jadwal-bulanan/jadwal-bulanan-list/jadwal-bulanan-list.page').then(
            (m) => m.JadwalBulananListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.JADWAL_BULANAN,
        },
      },
      {
        path: 'libur',
        loadComponent: () =>
          import('./schedule/libur/libur-list/libur-list.component').then((m) => m.LiburListPage),
        canActivate: [PermissionGuard],
        data: {
          access: Module.JADWAL_LIBUR,
        },
      },
      {
        path: 'atur-jadwal',
        loadComponent: () =>
          import('./schedule/atur-jadwal/atur-jadwal-list/atur-jadwal-list.component').then(
            (m) => m.AturJadwalListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.ATUR_JADWAL,
        },
      },
      {
        path: 'atur-jadwal/:uuid',
        loadComponent: () =>
          import('./schedule/atur-jadwal/atur-jadwal-detail/atur-jadwal-detail.component').then(
            (m) => m.AturJadwalDetailPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.ATUR_JADWAL,
        },
      },
      {
        path: 'daftar-ulang',
        loadComponent: () =>
          import('./daftar-ulang/daftar-ulang-list.page').then((m) => m.DaftarUlangListPage),
        canActivate: [PermissionGuard],
        data: {
          access: Module.DAFTAR_ULANG,
        },
      },
      {
        path: 'revisi-saldo-cuti',
        loadComponent: () =>
          import('./employee/cuti/revisi-saldo-list/revisi-saldo-list.page').then(
            (m) => m.RevisiSaldoListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.REVISI_SALDO_CUTI,
        },
      },
      {
        path: 'tukar-jadwal-karyawan',
        loadComponent: () =>
          import('./schedule/tukar-jadwal/tukar-jadwal-list/tukar-jadwal-list.page').then(
            (m) => m.TukarJadwalListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.TUKAR_JADWAL_KARYAWAN,
        },
      },
      {
        path: 'tukar-libur',
        loadComponent: () =>
          import('./schedule/tukar-libur/tukar-libur-list/tukar-libur-list.page').then(
            (m) => m.TukarLiburListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.TUKAR_JADWAL_LIBUR,
        },
      },
      {
        path: 'atur-master-lembur',
        loadComponent: () =>
          import('./atur-lembur/atur-master-lembur-list/atur-master-lembur-list.page').then(
            (m) => m.AturMasterLemburListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.MASTER_LEMBUR,
        },
      },
      {
        path: 'atur-tipe-lembur',
        loadComponent: () =>
          import('./atur-lembur/atur-tipe-lembur-list/atur-tipe-lembur-list.page').then(
            (m) => m.AturTipeLemburListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.TIPE_LEMBUR,
        },
      },
      {
        path: 'atur-rate-lembur',
        loadComponent: () =>
          import('./atur-lembur/atur-rate-lembur-list/atur-rate-lembur-list.page').then(
            (m) => m.AturRateLemburListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.RATE_LEMBUR,
        },
      },
      {
        path: 'atur-lembur',
        loadComponent: () =>
          import('./atur-lembur/atur-lembur-list/atur-lembur-list.page').then(
            (m) => m.AturLemburListPage,
          ),
        canActivate: [PermissionGuard],
        data: {
          access: Module.LEMBUR,
        },
      },
    ],
  },
  {
    path: 'daftar-ulang/manual/:karyawanUuid',
    loadComponent: () =>
      import('./daftar-ulang/daftar-ulang-verification/daftar-ulang-verification.page').then(
      (m) => m.DaftarUlangVerificationPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.DAFTAR_ULANG,
    },
  },
  {
    path: 'daftar-ulang/:uuid',
    loadComponent: () =>
      import('./daftar-ulang/daftar-ulang-verification/daftar-ulang-verification.page').then(
        (m) => m.DaftarUlangVerificationPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.DAFTAR_ULANG,
    },
  },
  {
    path: 'karyawan/add',
    loadComponent: () =>
      import('./employee/karyawan/karyawan-add/karyawan-add.page').then((m) => m.KaryawanAddPage),
    canActivate: [PermissionGuard],
    canDeactivate: [KaryawanAddCanLeaveGuard],
    data: {
      access: Module.DAFTAR_KARYAWAN,
    },
  },
  {
    path: 'karyawan/:uuid',
    loadComponent: () =>
      import('./employee/karyawan/karyawan-detail/karyawan-detail.page').then(
        (m) => m.KaryawanDetailPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.DAFTAR_KARYAWAN,
    },
  },
  {
    path: 'karyawan/:uuid/edit',
    loadComponent: () =>
      import('./employee/karyawan/karyawan-add/karyawan-add.page').then((m) => m.KaryawanAddPage),
    canActivate: [PermissionGuard],
    canDeactivate: [KaryawanAddCanLeaveGuard],
    data: {
      access: Module.DAFTAR_KARYAWAN,
    },
  },
  {
    path: 'karyawan/:uuid/fingerprint',
    loadComponent: () =>
      import('./employee/karyawan/karyawan-fingerprint/karyawan-fingerprint.page').then(
        (m) => m.KaryawanFingerprintPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.DAFTAR_KARYAWAN,
    },
  },
  {
    path: 'divisi/:uuid',
    loadComponent: () =>
      import('./employee/divisi/divisi-detail/divisi-detail.page').then((m) => m.DivisDetailPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.DAFTAR_DIVISI,
    },
  },
  {
    path: 'group/:uuid',
    loadComponent: () =>
      import('./employee/group/group-detail/group-detail.page').then((m) => m.GroupDetailPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.DAFTAR_GROUP,
    },
  },
  {
    path: 'pengajuan/:uuid',
    loadComponent: () =>
      import('./pengajuan/pengajuan-detail/pengajuan-detail.page').then(
        (m) => m.PengajuanDetailPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.PENGAJUAN,
    },
  },
  {
    path: 'libur/add',
    loadComponent: () =>
      import('./schedule/libur/libur-add/libur-add.page').then((m) => m.LiburAddPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.JADWAL_LIBUR,
    },
  },
  {
    path: 'libur/:uuid',
    loadComponent: () =>
      import('./schedule/libur/libur-detail/libur-detail.page').then((m) => m.LiburDetailPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.JADWAL_LIBUR,
    },
  },
  {
    path: 'libur/:uuid/edit',
    loadComponent: () =>
      import('./schedule/libur/libur-add/libur-add.page').then((m) => m.LiburAddPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.JADWAL_LIBUR,
    },
  },
  {
    path: 'jadwal/add',
    loadComponent: () =>
      import('./schedule/jadwal/jadwal-add/jadwal-add.page').then((m) => m.JadwalAddPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.POLA_JADWAL,
    },
  },
  {
    path: 'tukar-jadwal-karyawan/add',
    loadComponent: () =>
      import('./schedule/tukar-jadwal/tukar-jadwal-add/tukar-jadwal-add.page').then(
        (m) => m.TukarJadwalAddPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.TUKAR_JADWAL_KARYAWAN,
    },
  },
  {
    path: 'tukar-libur/add',
    loadComponent: () =>
      import('./schedule/tukar-libur/tukar-libur-add/tukar-libur-add.page').then(
        (m) => m.TukarLiburAddPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.TUKAR_JADWAL_LIBUR,
    },
  },
  {
    path: 'tukar-libur/:uuid',
    loadComponent: () =>
      import('./schedule/tukar-libur/tukar-libur-detail/tukar-libur-detail.page').then(
        (m) => m.TukarLiburDetailPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.TUKAR_JADWAL_LIBUR,
    },
  },
  {
    path: 'tukar-jadwal-karyawan/:uuid',
    loadComponent: () =>
      import('./schedule/tukar-jadwal/tukar-jadwal-detail/tukar-jadwal-detail.page').then(
        (m) => m.TukarJadwalDetailPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.TUKAR_JADWAL_KARYAWAN,
    },
  },
  {
    path: 'jadwal/:uuid',
    loadComponent: () =>
      import('./schedule/jadwal/jadwal-detail/jadwal-detail.page').then((m) => m.JadwalDetailPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.POLA_JADWAL,
    },
  },
  {
    path: 'atur-rate-lembur/add',
    loadComponent: () =>
      import('./atur-lembur/atur-rate-lembur-add/atur-rate-lembur-add.page').then(
        (m) => m.AturRateLemburAddPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.RATE_LEMBUR,
    },
  },
  {
    path: 'atur-rate-lembur/:uuid/edit',
    loadComponent: () =>
      import('./atur-lembur/atur-rate-lembur-add/atur-rate-lembur-add.page').then(
        (m) => m.AturRateLemburAddPage,
      ),
    canActivate: [PermissionGuard],
    data: {
      access: Module.RATE_LEMBUR,
    },
  },
  {
    path: 'atur-lembur/add',
    loadComponent: () =>
      import('./atur-lembur/atur-lembur-add/atur-lembur-add.page').then((m) => m.AturLemburAddPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.LEMBUR,
    },
  },
  {
    path: 'atur-lembur/:uuid/edit',
    loadComponent: () =>
      import('./atur-lembur/atur-lembur-add/atur-lembur-add.page').then((m) => m.AturLemburAddPage),
    canActivate: [PermissionGuard],
    data: {
      access: Module.LEMBUR,
    },
  },
  {
    path: 'absen',
    loadComponent: () => import('./absen/absen.page').then((m) => m.AbsenPage),
  },
  {
    path: 'restricted',
    loadComponent: () => import('./ungranted/ungranted.page').then((m) => m.UngrantedPage),
  },
];
